<template>
  <v-card flat>

    <v-card-text class="pt-4">
             <!-- <v-overlay :value="loading" absolute z-index="10" color="white" opacity="0.85">
     <atom-spinner :animation-duration="1000" :size="60" color="#ef394e" />
   </v-overlay> -->

      <v-form ref="form" v-model="isValid" @submit.prevent="submitForm">
        <v-row dense>
          <!-- تعداد در بسته -->
          <v-col cols="12">
            <v-text-field
              v-model.number="payload.package_quantity"
              label="تعداد در پک"
              outlined
              dense
              type="number"
              min="1"
              required
              :rules="[
                v => !!v || 'وارد کردن تعداد در بسته الزامی است',
                v => v > 0 || 'تعداد باید بیشتر از صفر باشد'
              ]"
              prepend-inner-icon="mdi-package-variant-closed"
            />
          </v-col>

          <!-- هزینه هر بسته -->
          <v-col cols="12">
            <PriceInput
              v-model="payload.package_cost"
              label="هزینه هر بسته"
              prepend-inner-icon="mdi-currency-usd"
              outlined
              dense
              :rules="[v => !!v || 'وارد کردن هزینه هر بسته الزامی است']"
            />
          </v-col>

          <!-- گام قیمت -->
          <v-col cols="12">
            <div class="d-flex align-start">
              <PriceInput
                v-model="payload.price_step"
                label="گام قیمت"
                prepend-inner-icon="mdi-step"
                outlined
                dense
                class="flex-grow-1"
                :rules="[v => !!v || 'وارد کردن گام قیمت الزامی است']"
              />
              <PriceCalculator 
                :pack="true" 
                :components="components" 
                :form-data="payload" 
                class="mr-2 mt-1"
              />
            </div>
          </v-col>

          <!-- روش ارسال -->
          <v-col cols="12">
            <v-select
              v-model="payload.shipping_method"
              label="روش ارسال"
              :items="shipping_methods"
              outlined
              dense
              style="border-radius: 8px"
              :menu-props="{ offsetY: true }"
            />
          </v-col>

          <!-- ================= بخش اقلام تشکیل‌دهنده (پک ترکیبی) ================= -->
          <v-col cols="12" class="mt-2">
            <v-card outlined class="rounded-lg pa-3 grey lighten-5">
              <div class="d-flex align-center justify-space-between mb-2">
                <span class="font-weight-bold text-subtitle-2">اقلام تشکیل‌دهنده پک</span>
                <v-chip 
                  small 
                  :color="isComponentsSumValid ? 'success' : 'error'" 
                  outlined
                  class="font-weight-bold"
                >
                  مجموع: {{ componentsSumQuantity }} از {{ payload.package_quantity || 0 }} عدد
                </v-chip>
              </div>

              <div class="mt-3">
                <div
                  v-for="(comp, index) in components"
                  :key="index"
                  class="d-flex align-center mb-3 pa-2 rounded-lg border bg-white flex-wrap flex-md-nowrap"
                  style="gap: 10px;"
                >
                  <!-- ۱. انتخاب محصول با عکس و شناسه -->
                  <v-autocomplete
                    v-model="comp.product_id"
                    :items="localProducts"
                    :loading="isLoadingProducts"
                    :search-input.sync="comp.searchProduct"
                    item-value="id"
                    item-text="title"
                    label="محصول سامانه"
                    outlined
                    dense
                    hide-details="auto"
                    class="flex-grow-1"
                    placeholder="انتخاب یا جستجوی محصول..."
                    :rules="[v => !!v || 'انتخاب محصول الزامی است']"
                    @change="onRowProductChange(comp)"
                  >
                    <!-- حالت انتخاب شده داخل فیلد -->
                    <template v-slot:selection="{ item }">
                      <div class="d-flex align-center text-truncate py-1">
                        <v-avatar size="24" rounded="sm" class="elevation-1 border ml-2 flex-shrink-0" color="grey lighten-4">
                          <v-img v-if="getItemImage(item)" :src="getItemImage(item)" aspect-ratio="1" contain />
                          <v-icon v-else x-small color="grey lighten-1">mdi-image-outline</v-icon>
                        </v-avatar>
                        <v-chip x-small color="primary" class="ml-1 font-weight-bold">ID-{{ item.id }}</v-chip>
                        <span class="text-truncate text-caption">{{ item.title }}</span>
                      </div>
                    </template>

                    <!-- آیتم‌های داخل منوی کشویی -->
                    <template v-slot:item="{ item }">
                      <v-list-item-avatar size="38" rounded="lg" class="elevation-1 border my-1 ml-2" color="grey lighten-4">
                        <v-img v-if="getItemImage(item)" :src="getItemImage(item)" aspect-ratio="1" contain>
                          <template #placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate size="14" color="grey lighten-1" />
                            </v-row>
                          </template>
                        </v-img>
                        <v-icon v-else small color="grey lighten-1">mdi-image-outline</v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium text-body-2 mb-1" style="line-height: 1.4;">
                          {{ item.title }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="d-flex align-center">
                          <v-chip x-small color="primary" outlined class="font-mono font-weight-bold">
                            کد: {{ item.id }}
                          </v-chip>
                          <span v-if="item.sku" class="text-caption grey--text mr-2">
                            SKU: {{ item.sku }}
                          </span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>

                  <!-- ۲. انتخاب تنوع محصول -->
                  <v-autocomplete
                    v-if="comp.skuList && comp.skuList.length > 0"
                    v-model="comp.sku_id"
                    :items="comp.skuList"
                    :loading="comp.isLoadingSkus"
                    item-value="id"
                    item-text="title"
                    label="تنوع محصول"
                    outlined
                    dense
                    hide-details="auto"
                    class="flex-grow-1"
                    placeholder="انتخاب تنوع..."
                    :rules="[v => !!v || 'انتخاب تنوع الزامی است']"
                  >
                    <template v-slot:selection="{ item }">
                      <div class="d-flex align-center text-truncate py-1">
                        <v-avatar size="24" rounded="sm" class="elevation-1 border ml-2 flex-shrink-0" color="grey lighten-4">
                          <v-img v-if="getRowSkuImage(item, comp.product_id)" :src="getRowSkuImage(item, comp.product_id)" aspect-ratio="1" contain />
                          <v-icon v-else x-small color="grey lighten-1">mdi-image-outline</v-icon>
                        </v-avatar>
                        <v-chip x-small color="secondary" class="ml-1 font-weight-bold">ID-{{ item.id }}</v-chip>
                        <span class="text-truncate text-caption">{{ item.title || item.sku }}</span>
                      </div>
                    </template>

                    <template v-slot:item="{ item }">
                      <v-list-item-avatar size="38" rounded="lg" class="elevation-1 border my-1 ml-2" color="grey lighten-4">
                        <v-img v-if="getRowSkuImage(item, comp.product_id)" :src="getRowSkuImage(item, comp.product_id)" aspect-ratio="1" contain />
                        <v-icon v-else small color="grey lighten-1">mdi-image-outline</v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium text-body-2 mb-1">
                          {{ item.title || item.sku || ('تنوع ' + item.id) }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="d-flex align-center flex-wrap gap-1">
                          <v-chip x-small color="secondary" outlined class="font-mono font-weight-bold ml-1">
                            ID: {{ item.id }}
                          </v-chip>
                          <v-chip v-if="item.sku" x-small color="grey darken-1" outlined class="font-mono ml-1">
                            {{ item.sku }}
                          </v-chip>
                          <span v-if="item.color_title || item.color?.title" class="text-caption grey--text mr-1">
                            رنگ: {{ item.color_title || item.color?.title }}
                          </span>
                          <span v-if="item.size_title || item.size?.title" class="text-caption grey--text mr-1">
                            سایز: {{ item.size_title || item.size?.title }}
                          </span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>

                  <!-- ۳. تعداد در پک -->
                  <v-text-field
                    v-model.number="comp.quantity"
                    label="تعداد"
                    type="number"
                    min="1"
                    outlined
                    dense
                    hide-details="auto"
                    style="max-width: 90px;"
                    :rules="[v => v > 0 || 'حداقل ۱']"
                  />

                  <!-- ۴. اکشن‌ها -->
                  <div class="d-flex align-center flex-shrink-0">
                    <v-btn icon color="success" @click="addComponent(index)" title="افزودن سطر">
                      <v-icon>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      color="error"
                      @click="removeComponent(index)"
                      :disabled="components.length === 1"
                      title="حذف سطر"
                    >
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </div>
                </div>

                <!-- اخطار عدم تطابق تعداد -->
                <v-alert
                  v-if="!isComponentsSumValid"
                  type="warning"
                  dense
                  text
                  class="mt-2 mb-0 text-caption"
                >
                  مجموع تعداد اقلام تشکیل‌دهنده ({{ componentsSumQuantity }}) باید دقیقاً برابر با «تعداد در پک» ({{ payload.package_quantity || 0 }}) باشد.
                </v-alert>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions class="grey lighten-4 pa-4 d-flex align-center">
      <v-btn class="btn-delete rounded-lg" @click="$emit('close')">
        <v-icon left>mdi-close</v-icon>
        انصراف
      </v-btn>

      <v-btn
        v-if="isLinked"
        outlined
        class="btn-refund rounded-lg mr-2"
        :loading="isUnlinking"
        :disabled="isSubmitting"
        @click="unlinkProduct"
      >
        <v-icon left>mdi-link-off</v-icon>
        قطع اتصال
      </v-btn>

      <v-spacer />

      <v-btn
        class="btn-get-code rounded-lg"
        :loading="isSubmitting"
        :disabled="!isValid || !isComponentsSumValid || isUnlinking"
        @click="submitForm"
      >
        <v-icon left>mdi-link-variant-plus</v-icon>
        تایید و اتصال باندل
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import PriceInput from "@/view/pages/uiBeautifier/priceInput";
import PriceCalculator from "../../components/PriceCalculator.vue";
   import { AtomSpinner } from "epic-spinners";

export default {
  name: "linkDigiProductModel_Pack",
  components: {
    PriceInput,
    PriceCalculator,
    AtomSpinner
  },
  props: {
    productDigi: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading:false,
      shipping_methods: [
        { text: "ارسال دیجی/فروشنده/سه ساعته", value: "all" },
        { text: "ارسال فروشنده / سه ساعته", value: "both" },
      ],
      isValid: false,
      isSubmitting: false,
      isUnlinking: false,
      isLinked: false,
      isBundle: false,
      listingId: null,

      localProducts: [],
      isLoadingProducts: false,

      // اقلام تشکیل‌دهنده (پک)
      components: [
        {
          product_id: null,
          sku_id: null,
          quantity: 1,
          skuList: [],
          isLoadingSkus: false,
          searchProduct: null,
        }
      ],

      payload: {
      components: [],
        package_quantity: 1,
        package_cost: 25000,
        shipping_method: "all",
        price_step: 15000,
      },
    };
  },
  computed: {
    componentsSumQuantity() {
      return this.components.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
    },
    isComponentsSumValid() {
      return this.componentsSumQuantity === Number(this.payload.package_quantity);
    }
  },
  async mounted() {
     this.loading = true;
     try {
       await this.fetchLocalProducts("");
       await this.fetchData();
     } finally {
       this.loading = false;
     }
   },
  methods: {
    async submitForm() {
  if (this.$refs.form && !this.$refs.form.validate()) return;

  this.isSubmitting = true;
  try {
    const apiPayload = {
      digikala_variant_id: Number(this.productDigi?.variant_id || this.productDigi?.id),
      package_quantity: Number(String(this.payload.package_quantity || 0).replace(/,/g, "")),
      shipping_method: this.payload.shipping_method || "both",
      package_cost: Number(String(this.payload.package_cost || 0).replace(/,/g, "")),
      price_step: Number(String(this.payload.price_step || 0).replace(/,/g, "")),
      // خواندن از this.components و فیلد sku_id
      components: this.components.map(item => ({
        product_id: Number(item.product_id),
        sku_id: item.sku_id ? Number(item.sku_id) : null,
        quantity: Number(item.quantity) || 1,
      })),
    };

    await this.$api.post("/v1/digikala/link/bundle-variants", apiPayload);

    this.$toast?.success("اتصال پک با موفقیت ثبت شد.");
    this.$emit("saved");
    this.$emit("close");
  } catch (error) {
    this.$toast?.error(error.response?.data?.message || "خطا در اتصال پک");
  } finally {
    this.isSubmitting = false;
  }
},
    getRowSkuImage(sku, parentProductId) {
      if (!sku) return "";
      let img = sku.main_image?.url || sku.image || sku.thumbnail || sku.cover || sku.img_url;
      if (!img && (Array.isArray(sku.images) || Array.isArray(sku.gallery))) {
        const list = sku.images || sku.gallery;
        if (list.length > 0) {
          const first = list[0];
          img = typeof first === "string" ? first : (first?.url || first?.src || first?.path);
        }
      }
      if (!img && parentProductId) {
        const parentProduct = this.localProducts.find(p => p.id === parentProductId);
        if (parentProduct) img = this.getItemImage(parentProduct);
      }
      if (!img) return "";
      if (typeof img === "string" && !img.startsWith("http") && !img.startsWith("data:")) {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || window.location.origin;
        return `${baseUrl.replace(/\/+$/, "")}/${img.replace(/^\/+/, "")}`;
      }
      return img;
    },

    getItemImage(item) {
      if (!item) return "";
      let img = item.main_image?.url || item.image || item.cover || item.cover_image || item.img_url;
      if (!img && (Array.isArray(item.images) || Array.isArray(item.gallery))) {
        const list = item.images || item.gallery;
        if (list.length > 0) {
          const first = list[0];
          img = typeof first === "string" ? first : (first?.url || first?.src || first?.path);
        }
      }
      if (!img) return "";
      if (typeof img === "string" && !img.startsWith("http") && !img.startsWith("data:")) {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || window.location.origin;
        return `${baseUrl.replace(/\/+$/, "")}/${img.replace(/^\/+/, "")}`;
      }
      return img;
    },

    async onRowProductChange(rowComp) {
      rowComp.sku_id = null;
      rowComp.skuList = [];

      if (!rowComp.product_id) return;

      rowComp.isLoadingSkus = true;
      try {
        const { data } = await this.$api.get(`/v1/products/${rowComp.product_id}/sku-list`);
        rowComp.skuList = data?.data || data || [];
      } catch (e) {
        console.error("خطا در دریافت تنوع‌های سطر", e);
        rowComp.skuList = [];
      } finally {
        rowComp.isLoadingSkus = false;
      }
    },

    addComponent(index) {
      const newRow = {
        product_id: null,
        sku_id: null,
        quantity: 1,
        skuList: [],
        isLoadingSkus: false,
        searchProduct: null,
      };
      this.components.splice(index + 1, 0, newRow);
    },

    removeComponent(index) {
      if (this.components.length > 1) {
        this.components.splice(index, 1);
      }
    },

async fetchData() {
  const variantId = this.productDigi?.variant_id || this.productDigi?.id;
  if (!variantId) return;

  let calculatedShipping = "both";

  try {
    const res2 = await this.$api.get(`/v1/marketplace-listings/digi/get-variant`, {
      params: { variant_id: variantId }
    });
    const vData = res2.data?.data?.variant || res2.data?.data || res2.data?.variant;

    if (vData) {
      const isFbd = vData.is_fbd_active === true || 
                    vData.is_fbd_active === 1 || 
                    vData.is_fbd_active === "1" || 
                    vData.is_fbd_active === "true";

      calculatedShipping = isFbd ? "all" : "both";
    }
  } catch (err) {
    console.warn("خطا در استعلام روش ارسال:", err);
  }

  this.$set(this.payload, "shipping_method", calculatedShipping);

  try {
    const res = await this.$api.get(`/v1/marketplace-listings/digi/get-listing`, {
      params: { variant_id: variantId, marketplace: "digikala" }
    });

    const listing = res?.data?.data?.listing;
    if (listing) {
      this.isLinked = listing.status === "linked";
      this.listingId = listing.id;

      this.payload.shipping_method = listing.shipping_method || calculatedShipping;
      this.payload.package_cost = listing.package_cost ?? 25000;
      this.payload.price_step = listing.price_step ?? 15000;
      this.payload.package_quantity = listing.package_quantity ?? 1;

      // لود کردن اقلام پک داخل آرایه components
      const rawComponents = listing.components || listing.items || [];
      if (rawComponents.length > 0) {
        this.components = rawComponents.map(c => ({
          product_id: c.product_id,
          sku_id: c.sku_id || c.product_sku_id || null,
          quantity: c.quantity || 1,
          skuList: [],
          isLoadingSkus: false,
          searchProduct: null,
        }));

        // دریافت لیست SKUها برای محصول هر سطر جهت نمایش درست
        this.components.forEach(row => {
          if (row.product_id) {
            this.fetchRowSkus(row);
          }
        });
      }
    }
  } catch (error) {
    console.error("خطا در بازیابی اطلاعات پک", error);
  }
},

// متد کمکی برای پر کردن لایو تنوع‌های هر سطر
async fetchRowSkus(rowComp) {
  rowComp.isLoadingSkus = true;
  try {
    const { data } = await this.$api.get(`/v1/products/${rowComp.product_id}/sku-list`);
    rowComp.skuList = data?.data || data || [];
  } catch (e) {
    rowComp.skuList = [];
  } finally {
    rowComp.isLoadingSkus = false;
  }
},


    async fetchLocalProducts(searchQuery) {
      this.isLoadingProducts = true;
      try {
        const { data } = await this.$api.get(`/v1/products/list`, {
          params: { search: searchQuery },
        });
        this.localProducts = data?.data?.data || data?.data || data || [];
      } catch (error) {
        console.error("خطا در دریافت لیست محصولات سامانه", error);
      } finally {
        this.isLoadingProducts = false;
      }
    },

    async unlinkProduct() {
      const confirmed = this.$modal?.yesNo
        ? await this.$modal.yesNo("آیا از قطع اتصال این تنوع از سامانه اطمینان دارید؟")
        : confirm("آیا از قطع اتصال این تنوع از سامانه اطمینان دارید؟");

      if (!confirmed) return;

      this.isUnlinking = true;
      try {
        const variantId = Number(this.productDigi?.variant_id || this.productDigi?.id);
        await this.$api.post(`/v1/marketplace-listings/unlink-by-variant`, {
          marketplace: "digikala",
          external_variant_id: variantId
        });

        this.$toast?.success("اتصال با موفقیت قطع شد.");
        this.$emit("saved");
        this.$emit("close");
      } catch (error) {
        this.$toast?.error(error.response?.data?.message || "خطا در قطع اتصال");
      } finally {
        this.isUnlinking = false;
      }
    },


  },
};
</script>

<style scoped>
.gap-1 { gap: 4px; }
.gap-2 { gap: 8px; }
.gap-3 { gap: 12px; }
</style>
